import "@emotion/react/jsx-runtime";
import React__default, { useContext } from "react";
const TDSContext = /*#__PURE__*/React__default.createContext({
  useTDS: false
});

const useTDSContext = () => useContext(TDSContext);

export { useTDSContext };